import {
  ScheduledCampaignDto,
  ActionDto,
  Contact,
  GetNameandnumberVm,
  GetUserOutcomeStatsDto,
  GetUserCampaignScheduleVm,
  NameAndNumberCount,
  TenantRoutingAreaDto,
  ListScheduledCampaignsVm,
  CampaignDialType,
} from '../models';

import { OBCall } from '../models/obcall';

import {
  Action,
  Answers,
  Blade,
  Inputs,
  Master,
  QuestionInputs,
  Queue,
  System,
  Variables,
} from '../code';

export interface State {
  action?: Action;
  allowBack: boolean;
  allowRefresh: boolean;
  answers?: Answers;
  autoAnswer?: boolean;
  auxState?: boolean;
  blade?: Blade;
  campaignId?: number;
  campaignScriptOpen?: boolean;
  closeDisable?: boolean;
  closeScript?: true | 'contact' | 'history';
  confirm?: string;
  contact?: Contact;
  defaultTenantId?: number;
  dialType?: CampaignDialType;
  hasCallbacks?: boolean;
  hasIBScheduled: boolean;
  hasNameAndNumber?: boolean;
  history?: ActionDto[];
  ibLaunched: boolean;
  inputs?: QuestionInputs;
  isFastVoicemail: boolean;
  master?: Master;
  msgs?: NameAndNumberCount[];
  nailupTimeLimit?: number;
  noNavBack?: boolean;
  obContinue?: boolean;
  obLaunched?: boolean;
  obMessage?: string;
  omniChannel?: boolean;
  oncall?: boolean;
  pendingCampaigns?: ListScheduledCampaignsVm;
  positions?: string[];
  postCallSurveyCampaign?: number;
  postCallSurveyCancel?: boolean;
  postCallSurveyData?: string;
  postCallSurveyPhone?: string;
  postCallSurveyRecordId?: number;
  qInputs?: Inputs;
  qNo?: number;
  qText?: string;
  queues?: Queue[];
  recordId?: number;
  routingAreas?: TenantRoutingAreaDto[];
  scheduledCampaigns?: ScheduledCampaignDto[];
  scriptDisable?: boolean;
  standbyLimit: number;
  system?: System;
  tasksPresented?: boolean;
  testMode?: boolean;
  transferCall?: {
    options: { agent3Way: boolean; stopRecording: boolean };
    thirdPartyNumber: string;
  };
  userCampaignSchedule?: GetUserCampaignScheduleVm;
  userOutcomeStats?: GetUserOutcomeStatsDto[];
  variables?: Variables;
  voicemailMsg?: GetNameandnumberVm;
  waitingforob?: boolean;
  waitingobcall?: OBCall;
}

export const initalState: State = {
  action: undefined,
  allowBack: true,
  allowRefresh: true,
  answers: undefined,
  autoAnswer: undefined,
  auxState: false,
  contact: undefined,
  closeDisable: undefined,
  closeScript: undefined,
  history: undefined,
  inputs: undefined,
  master: undefined,
  pendingCampaigns: undefined,
  positions: undefined,
  qInputs: undefined,
  qNo: undefined,
  qText: undefined,
  routingAreas: undefined,
  recordId: undefined,
  scheduledCampaigns: undefined,
  scriptDisable: undefined,
  standbyLimit: 3,
  system: undefined,
  variables: undefined,
  hasNameAndNumber: undefined,
  hasCallbacks: undefined,
  voicemailMsg: undefined,
  userOutcomeStats: undefined,
  testMode: false,
  obContinue: false,
  obLaunched: false,
  ibLaunched: false,
  hasIBScheduled: false,
  oncall: false,
  isFastVoicemail: false,
  waitingforob: false,
  obMessage: undefined,
  nailupTimeLimit: -1,
  userCampaignSchedule: undefined,
  tasksPresented: false,
  waitingobcall: undefined,
  campaignId: undefined,
  queues: undefined,
  postCallSurveyCancel: undefined,
  postCallSurveyData: undefined,
  postCallSurveyPhone: undefined,
  postCallSurveyCampaign: undefined,
  postCallSurveyRecordId: undefined,
  msgs: undefined,
  campaignScriptOpen: undefined,
};
